/**
 * A page served over TLS may not load audio from a plain-HTTP address: browsers
 * either upgrade the request to `https://` and fail, or refuse it outright. The
 * feed's published address comes from its output row, so this is a fact about the
 * deployment rather than about this app — and the honest thing to do is say which
 * address cannot be loaded and why, not to fail silently on a dead play button.
 */
export function isMixedContentBlocked(
  streamUrl: string,
  pageProtocol: string,
): boolean {
  return pageProtocol === "https:" && streamUrl.startsWith("http://");
}

export function pageProtocol(): string {
  return typeof window === "undefined" ? "http:" : window.location.protocol;
}

/** What the `<audio>` element's error code actually means, in a listener's words. */
export function describeMediaError(error: MediaError | null): string {
  switch (error?.code) {
    case MediaError.MEDIA_ERR_ABORTED:
      return "Playback was stopped before the stream arrived.";
    case MediaError.MEDIA_ERR_NETWORK:
      return "The connection to the stream dropped.";
    case MediaError.MEDIA_ERR_DECODE:
      return "The audio arriving on this stream could not be decoded.";
    case MediaError.MEDIA_ERR_SRC_NOT_SUPPORTED:
      return "The stream address could not be played.";
    default:
      return "The stream could not be played.";
  }
}
